import api from '@/apis/di/budgetChapterAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance, computed } from 'vue';

// Combo grid Khoản
export const useBudgetChapterComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onBudgetChapterComboboxLoadData = (payload, row, column, customData) => {
    payload.sort = 'budget_chapter_code';
    let extend = [{ Field: 'active', Value: true }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns += ',active';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // config columns combo
  const budgetChapterComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã chương',
        dataField: 'budget_chapter_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên chương',
        dataField: 'budget_chapter_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_chapter_code',
    valueField: 'budget_chapter_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    quickSearch: 'BudgetChapterQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => x.active,
    },
    comboboxLoadData: onBudgetChapterComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    budgetChapterComboConfig,
    onBudgetChapterComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
